
<script type="text/babel">
// import langSets from './dataMap/langSets'
import dateFunc from '@/utils/dateFunc'
import moment from 'moment'
import EventCard from '@/components/EventCard.vue'
import fcheader from '@/components/header'
import {DateUtil} from '@/utils/date.js'
import MovementShiftWindowMask from '@/components/MovementShiftWindowMask'
import PrintSelectDialog from '@/components/PrintSelectDialog'
import dialog from '@/components/Dialog'
import {StringUtil} from '@/utils/StringUtil'
import apiConfig from '../../config/api.config'
export default {
  props: {
    // 便事件
    events: { // events will be displayed on calendar
      type: Array,
      default: () => []
    },
    // 便信息List
    shiftInfoList: {
      type: Array,
      default: () => []
    },
    // 语言
    locale: {
      type: String,
      default: 'en'
    },
    firstDay: {
      type: Number | String,
      validator (val) {
        let res = parseInt(val)
        return res >= 0 && res <= 6
      },
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'event-card': EventCard,
    'fc-header': fcheader,
    MovementShiftWindowMask,
    'v-dialog': dialog,
    PrintSelectDialog
  },
  updated () {
    if (this.isFirstIn) {
      this.scrollToLocation()
      this.isFirstIn = false
    }
  },
  created () {
  },
  mounted () {
    // 初始化当前月
    let dateStr = this.$route.query.currentDate
    if (dateStr === undefined || StringUtil.isEmpty(dateStr)) {
      this.currentMonth = moment().startOf('month')
    } else {
      this.currentMonth = moment(dateStr, 'YYYYMM').startOf('month')
    }
    this.$axios.get('shift/selectRouteStationInfo').then(response => {
      sessionStorage.setItem('routeStationInfo', JSON.stringify(response.data.routeStationInfo))
    })
  },
  data () {
    return {
      apiConfig: apiConfig,
      // // 当前月
      currentMonth: moment().startOf('month'),
      // 一个格子事件上限
      eventLimit: 4,
      // 显示更多
      showMore: false,
      morePos: {
        top: 0,
        left: 0
      },
      selectDay: {},
      weeks: ['日', '月', '火', '水', '木', '金', '土'],
      // 当前是否为日历
      isCalendar: false,
      // 便状态
      shiftMovementStatus: [
        '未公開',
        '公開中',
        '業務中',
        '業務終了',
        '強制終了',
        '未公開'
      ],
      // 便详细信息
      shiftDetail: {
        title: {type: String, default: ''},
        shiftId: {type: String, default: ''},
        driverNameKana: {type: String, default: ''},
        vehicleName: {type: String, default: ''},
        vehicleId: {type: String, default: ''},
        passengerNumber: {type: Number, default: 0},
        driverName: {type: String, default: ''},
        moveShiftTime: '',
        startPlace: {type: String, default: ''},
        startTime: {type: String, default: ''},
        arrivePlace: {type: String, default: ''},
        arriveTime: {type: String, default: ''},
        openFlag: {type: Number, default: 0}
      },
      // // 是否定位的tr
      // locationTr: -1,
      // 状态行颜色
      trColors: [
        // 未公开
        'bgc5',
        // 公开中
        'bgc1',
        // 运行中
        'bgc4',
        // 终了
        'bgc10',
        // 强制终了
        'bgc10'
      ],
      trBorders: [
        // 未公开
        'border-color1',
        // 公开中
        'border-color2',
        // 运行中
        'border-color3',
        // 终了
        'border-color4',
        // 强制终了
        'border-color4'
      ],
      // 状态背景
      statusBtnBgs: [
        // 非公开
        'status-btn-bg2',
        // 公开中
        'status-btn-bg1',
        // 运行中
        'status-btn-bg3',
        // 终了
        'status-btn-bg3',
        // 强制终了
        'status-btn-bg3',
        // 非公開(区域外便)
        'status-btn-bg4'
      ],
      isPrint: false,
      // 全选check
      allCheck: false,
      // 出力Dialog
      showPrintDialog: false,
      dialogPrintOption: {
        showNo: true,
        text: 'データをダウンロードします。<br/>よろしいですか？',
        cancelButtonText: 'キャンセル',
        confirmButtonText: '実行'
      },
      isFirstIn: true

    }
  },
  watch: {
    allCheck: function () {
      if (this.allCheck) {
        for (let i = 0; i < this.checkboxes.length; i++) {
          this.checkboxes[i] = true
        }
      } else {
        for (let i = 0; i < this.checkboxes.length; i++) {
          this.checkboxes[i] = false
        }
      }
    },
    loading: function () {
      if (!this.loading) {
        this.isFirstIn = true
      }
    }
  },
  computed: {
    currentDates () {
      return this.getCalendar()
    },
    statusList () {
      let statusList = []
      // 获取shift的状态
      for (let shiftInfo of this.shiftInfoList) {
        statusList.push(this.checkStatus(shiftInfo))
      }
      return statusList
    },
    // 初始化checkbox
    checkboxes () {
      let checkboxes = []
      for (let i = 0; i < this.shiftInfoList.length; i++) {
        checkboxes.push(false)
      }
      return checkboxes
    }
  },
  methods: {
    // 通知父组件月份改变
    emitChangeMonth (firstDayOfMonth) {
      this.currentMonth = firstDayOfMonth
      let start = dateFunc.getMonthViewStartDate(firstDayOfMonth, this.firstDay)
      let end = dateFunc.getMonthViewEndDate(firstDayOfMonth, this.firstDay)
      this.$emit('changeMonth', start, end, firstDayOfMonth)
    },
    moreTitle (date) {
      if (!date) return ''
      return moment(date).format('ll')
    },
    getCalendar () {
      // calculate 2d-array of each month
      let monthViewStartDate = dateFunc.getMonthViewStartDate(this.currentMonth, this.firstDay)
      let calendar = []

      for (let perWeek = 0; perWeek < 6; perWeek++) {
        let week = []

        for (let perDay = 0; perDay < 7; perDay++) {
          week.push({
            monthDay: monthViewStartDate.date(),
            isToday: monthViewStartDate.isSame(moment(), 'day'),
            isCurMonth: monthViewStartDate.isSame(this.currentMonth, 'month'),
            weekDay: perDay,
            date: moment(monthViewStartDate),
            events: this.slotEvents(monthViewStartDate)
          })

          monthViewStartDate.add(1, 'day')
        }

        calendar.push(week)
      }

      return calendar
    },
    slotEvents (date) {
      // find all events start from this date
      // let cellIndexArr = []
      let thisDayEvents = this.events.filter(day => {
        let st = moment(day.start)
        let ed = moment(day.end ? day.end : st)

        return date.isBetween(st, ed, null, '[]')
      })

      // sort by duration
      thisDayEvents.sort((a, b) => {
        if (!a.cellIndex) return 1
        if (!b.cellIndex) return -1
        return a.cellIndex - b.cellIndex
      })

      // mark cellIndex and place holder
      for (let i = 0; i < thisDayEvents.length; i++) {
        thisDayEvents[i].cellIndex = thisDayEvents[i].cellIndex || (i + 1)
        thisDayEvents[i].isShow = true
        if (thisDayEvents[i].cellIndex === i + 1 || i > 2) continue
        thisDayEvents.splice(i, 0, {
          title: 'holder',
          cellIndex: i + 1,
          start: date.format(),
          end: date.format(),
          isShow: false
        })
      }

      return thisDayEvents
    },
    selectThisDay (day, jsEvent) {
      this.selectDay = day
      this.showMore = true
      this.morePos = this.computePos(event.target)
      this.morePos.top -= 100
      let events = day.events.filter(item => {
        return item.isShow === true
      })
      this.$emit('moreClick', day.date, events, jsEvent)
    },
    computePos (target) {
      let eventRect = target.getBoundingClientRect()
      let pageRect = this.$refs.dates.getBoundingClientRect()
      return {
        left: eventRect.left - pageRect.left,
        top: eventRect.top + eventRect.height - pageRect.top
      }
    },
    dayClick (day, jsEvent) {
      this.$emit('dayClick', day, jsEvent)
    },
    eventClick (event, jsEvent) {
      if (!event.isShow) return

      jsEvent.stopPropagation()
      let pos = this.computePos(jsEvent.target)
      this.$emit('eventClick', event, jsEvent, pos)
    },
    showList () {
      this.isCalendar = false
    },
    showCalendar () {
      this.isCalendar = true
    },
    // 显示预约状况(为公开状态，若openFlag = 0按钮无效，弹窗提示)
    showReservationStatus (shiftInfo) {
      if (shiftInfo.openFlag === 1) {
        this.shiftDetail = shiftInfo
        sessionStorage.setItem('shift', JSON.stringify(this.shiftDetail))
        this.$router.push({name: 'ReservationStatus', query: {shiftId: shiftInfo.shiftId, from: 'MovementShift'}})
      } else {
        this.dialogPrintOption.text = 'この運行便は非公開状態です。'
        this.dialogPrintOption.showNo = false
        this.dialogPrintOption.confirmButtonText = 'OK'
        this.showPrintDialog = true
        this.$refs.printDialog.confirm().then(() => {
          this.showPrintDialog = false
        }).catch(() => {
          this.showPrintDialog = false
        })
      }
    },
    // 显示便详细
    showShiftDetail (shiftInfo) {
      this.shiftDetail = shiftInfo
    },
    // 跳转便详细页面
    goDetail (shiftInfo) {
      this.$router.push({name: 'MovementShiftDetail', query: {shiftId: shiftInfo.shiftId, from: 'MovementShift'}})
    },
    // 获取正在业务开始的便的位置
    getLocationTr () {
      for (let i = 0; i < this.shiftInfoList.length; i++) {
        let shiftInfo = this.shiftInfoList[i]
        if (shiftInfo.businessStatus === 2) {
          return i
        }
      }
      return 0
    },
    // 滑动到正在运行的便
    scrollToLocation () {
      this.$nextTick(() => {
        let locationTr = this.getLocationTr()
        console.log(locationTr)
        let div = document.getElementById('shift-list')
        if (div !== null) { div.scrollTop = locationTr * 59 }
      })
    },
    // 跳转便登录
    shiftRegistration () {
      this.$router.push({ name: 'ShiftLogin' })
    },
    // 检查状态
    checkStatus (shiftInfo) {
      if (shiftInfo === undefined) {
        return 0
      }
      if (shiftInfo.shiftId === 'B1173') {
        console.log(shiftInfo.coercionStopFlag)
      }
      if (!shiftInfo.businessStatus || shiftInfo.businessStatus === 1) {
        if (shiftInfo.openFlag === 0) {
          if (shiftInfo.transportKind === 0) {
            return 0
          } else {
            return 5
          }
        } else {
          return 1
        }
      } else if (shiftInfo.coercionStopFlag === 1) {
        return 4
      } else {
        return shiftInfo.businessStatus
      }
    },
    // MM月dd日格式
    MMdd (date) {
      // console.log(date)
      return DateUtil.yMd2M_d_W(date)
    },
    // 变为出力模式
    goPrint () {
      // sessionStorage.setItem('PrintShiftList', JSON.stringify(this.shiftInfoList))
      // this.$router.push({name: 'MovementShiftPrint', query: {printDate: this.currentMonth.format('YYYYMM')}})
      this.isPrint = true
    },
    // csv出力
    print () {
      let printList = []
      if (this.allCheck) {
        printList = this.shiftInfoList
      } else {
        for (let i = 0; i < this.shiftInfoList.length; i++) {
          if (this.checkboxes[i]) {
            let shiftInfo = this.shiftInfoList[i]
            // shiftInfo.moveShiftTime = this.MMdd(shiftInfo.moveShiftTime)
            // console.log(shiftInfo)
            printList.push(shiftInfo)
          }
        }
      }
      if (printList.length === 0) {
        this.dialogPrintOption.text = '運行便を選択してください。'
        this.dialogPrintOption.showNo = false
        this.dialogPrintOption.confirmButtonText = 'OK'
      } else {
        this.dialogPrintOption.text = 'データをダウンロードします。<br/>よろしいですか？'
        this.dialogPrintOption.showNo = true
        this.dialogPrintOption.cancelButtonText = 'キャンセル'
        this.dialogPrintOption.confirmButtonText = '実行'
      }
      // console.log(printList)
      this.showPrintDialog = true
      this.$refs.printDialog.confirm().then(() => {
        if (printList.length !== 0) {
          this.$axios.post('shift/exportShiftCsv', printList, {responseType: 'arraybuffer'}).then((res) => {
            let fileName = '運行便一覧.csv'
            let blob = new Blob([res.data], { type: 'application/x-xls' })
            if (window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName)
            } else {
              var link = document.createElement('a')
              link.href = window.URL.createObjectURL(blob)
              link.download = fileName
              link.click()
              window.URL.revokeObjectURL(link.href)
            }
          }).catch((error) => {
            console.log(error)
            let dialogPrintOption = {
              showNo: false,
              text: '予期せぬエラーが発生しました。',
              confirmButtonText: 'OK'
            }
            this.dialogPrintOption = dialogPrintOption
            this.showPrintDialog = true
            this.$refs.printDialog.confirm().then(() => {
              this.showPrintDialog = false
            })
          })
        }
        this.showPrintDialog = false
      }).catch(() => {
        this.showPrintDialog = false
      })
    },
    goPrintShiftStatisticExcel () {
      this.dialogPrintOption.text = 'データをダウンロードします。<br/>よろしいですか？'
      this.dialogPrintOption.showNo = true
      this.dialogPrintOption.cancelButtonText = 'キャンセル'
      this.dialogPrintOption.confirmButtonText = '実行'

      this.showPrintDialog = true
      this.$refs.printDialog.confirm().then(() => {
        this.showPrintDialog = false
        this.downLoadShiftStatisticExcel()
      })
        .catch(() => {
          this.showPrintDialog = false
        })
    },

    downLoadShiftStatisticExcel () {
      this.$axios.get('shift/isDataExist', {
        params: { 'yearMonth': this.currentMonth.format('YYYYMM') }}).then(response => {
        if (response.data.dataCnt > 0) {
          let baseUrl = apiConfig.baseUrl
          var elemIF = document.createElement('iframe')
          elemIF.src = baseUrl + 'shift/downShiftStatisticExcelReport?yearMonth=' + this.currentMonth.format('YYYYMM')
          elemIF.style.display = 'none'
          this.$refs.movementShiftComponent.appendChild(elemIF)
        } else {
          this.dialogPrintOption.text = '出力データがありません。'
          this.dialogPrintOption.showNo = false
          this.dialogPrintOption.confirmButtonText = 'OK'
          this.showPrintDialog = true
          this.$refs.printDialog.confirm().then(() => {
            this.showPrintDialog = false
          }).catch(() => {
            this.showPrintDialog = false
          })
        }
        // document.body.removeChild(elemIF)
      })
    },
    goPrintExcel () {
      this.dialogPrintOption.text = 'データをダウンロードします。<br/>よろしいですか？'
      this.dialogPrintOption.showNo = true
      this.dialogPrintOption.cancelButtonText = 'キャンセル'
      this.dialogPrintOption.confirmButtonText = '実行'

      this.showPrintDialog = true
      this.$refs.printDialog.confirm().then(() => {
        this.showPrintDialog = false
        this.downPrintExcel()
      })
        .catch(() => {
          this.showPrintDialog = false
        })
    },
    downPrintExcel () {
      this.$axios.get('shift/existShiftData', {
        params: { date: this.currentMonth.format('YYYYMM') }}).then(response => {
        let count = response.data.count
        if (count > 0) {
          let baseUrl = apiConfig.baseUrl
          var elemIF = document.createElement('iframe')
          elemIF.src = baseUrl + 'shift/exportShiftExcel?date=' + this.currentMonth.format('YYYYMM')
          elemIF.style.display = 'none'
          this.$refs.movementShiftComponent.appendChild(elemIF)
        } else {
          this.dialogPrintOption.text = '出力データがありません。'
          this.dialogPrintOption.showNo = false
          this.dialogPrintOption.confirmButtonText = 'OK'
          this.showPrintDialog = true
          this.$refs.printDialog.confirm().then(() => {
            this.showPrintDialog = false
          }).catch(() => {
            this.showPrintDialog = false
          })
        }
        // document.body.removeChild(elemIF)
      })
    },
    cancel () {
      for (let i = 0; i < this.checkboxes.length; i++) {
        this.checkboxes[i] = false
      }
      this.allCheck = false
      this.isPrint = false
    },
    showOpenFlagMessage () {
      this.dialogPrintOption.text = 'この便は予約されました。非公開できません。'
      this.dialogPrintOption.showNo = false
      this.dialogPrintOption.confirmButtonText = 'OK'
      this.showPrintDialog = true
      this.$refs.printDialog.confirm().then(() => {
        this.showPrintDialog = false
      }).catch(() => {
        this.showPrintDialog = false
      })
    },
    hhmm (date) {
      let hour = parseInt(date.substr(0, 2))
      if (hour < 10 && hour > 0) {
        return date.substr(1, 4)
      }
      return date
    }
  },
  filters: {
    localeWeekDay (weekday, firstDay, locale) {
      firstDay = parseInt(firstDay)
      const localMoment = moment().locale(locale)
      return localMoment.localeData().weekdaysShort()[(weekday + firstDay) % 7]
    }
  }
}

</script>

<template>
  <div ref="movementShiftComponent" class="comp-full-calendar">
    <!-- header pick month -->
    <fc-header :current-month="currentMonth"
      :first-day="firstDay"
      :locale="locale"
      :is-print="isPrint"
      @change="emitChangeMonth">

      <div slot="header-left">
        <slot name="fc-header-left">
          <div class="clearfix" style="padding-left:15px;">
            <div class="left-btn col-md-6 column"
            @click="showList"
            style="border-bottom-left-radius: 10px;border-top-left-radius: 10px;"
            :style="{color:isCalendar?'rgb(204,204,204)':''}">
              <img v-show="!isCalendar" src="@/assets/button/list_button1.png" class="left-img"/>
              <img v-show="isCalendar" src="@/assets/button/list_button2.png" class="left-img"/><span :class="isCalendar?'F9-M-19':'F1-M-19'">リスト</span>
            </div>
            <div class="left-btn col-md-6 column"
            @click="showCalendar"
            style="border-bottom-right-radius: 10px;border-top-right-radius: 10px;"
            :style="{color:isCalendar?'':'rgb(204,204,204)'}">
              <img v-show="isCalendar" src="@/assets/button/calender_button1.png" class="left-img"/>
              <img v-show="!isCalendar" src="@/assets/button/calender_button2.png" class="left-img"/><span :class="isCalendar?'F1-M-19':'F9-M-19'">カレンダー</span>
            </div>
          </div>
        </slot>
      </div>

      <div slot="header-right">
        <slot name="fc-header-right">
          <div class="row clearfix">
            <div class="col-md-12 column">
              <div class="row clearfix">
                  <!-- <button class="btn common-btn F2-M-19" style="width:30%" @click="goPrintExcel">利用集計出力</button>
                  <button class="btn common-btn F2-M-19" style="width:30%" @click="goPrint">一覧出力</button> -->
                  <div  class="col-md-3 column"></div>
                  <a href="#modal-container-print-selector" data-toggle="modal" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">
                    <button class="btn common-btn F2-M-19" style="width:30%" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">出力</button>
                  </a>
                  <button class="btn common-btn F2-M-19" style="width:30%" @click="shiftRegistration()">+ 新規登録</button>
              </div>
            </div>
          </div>
        </slot>
      </div>
    </fc-header>

    <!--ShiftList-->
    <div class="col-md-12 column " style="display:flex;flex-direction: column;" v-show="!isCalendar" element-loading-text="ローディング中">
      <div class="table-container" style="margin-left:0px;margin-right:0px;height:100%;">
        <div class=" table-header" style="padding-right:10px;">
          <table>
            <thead>
              <tr class="theader bgc9">
                <!-- 運行日時、便ID、便名、車種、車両ID、ドライバー名を -->
              <td v-show="isPrint" class="trborder checkbox-td htd">
                  <div >
                      <input type="checkbox" v-model="allCheck" class="checkbox-style">
                  </div>
              </td>
              <td class="trborder htd F2-R-15" :style="isPrint?'width:20%':'width:24%'">運行日時</td>
              <td  class="trborder shift-id htd F2-R-15">便ID</td>
              <td  class="trborder parent-shift-id htd F2-R-15">区域内便ID</td>
              <td class="trborder shift-name htd F2-R-15">便名</td>
              <td class="trborder shift-vehicle htd F2-R-15">車両</td>
              <td class="trborder shift-driver htd F2-R-15">ドライバー</td>
              <td class="trborder shift-rese htd F2-R-15">予約（予約者/定員数）</td>
              <!-- <td class="shift-gap htd"></td> -->
              <td class="shift-status htd"></td>
            </tr>
            </thead>
          </table>
        </div>
        <div class="table-body scrollbar" id="shift-list">
          <table class="table">
            <tbody>
            <tr class="contenttr bgc5h"
            v-for='(shiftInfo, index) in shiftInfoList'
            :key="shiftInfo.shiftId"
            :class="trColors[statusList[index]]"
            :style="(statusList[index]==1||statusList[index]==2)?'color:#fff':'color:rgb(80,80,80)'">
            <!-- checkbox -->
                <td v-show="isPrint" :class="trBorders[statusList[index]]" class="checkbox-td">
                  <div >
                      <input type="checkbox" v-model="checkboxes[index]" class="checkbox-style">
                  </div>
                </td>
            <!-- shift_move_time -->
                <td class="bodytext" :class="trBorders[statusList[index]]" @click="goDetail(shiftInfo)" :style="isPrint?'width:20%':'width:24%'">
                  <div class="row clearfix">
                    <div class="col-md-6 column move-day F3-R-19-m">
                      {{MMdd(shiftInfo.moveShiftTime)}}
                    </div>

                    <div class="col-md-3 column move-start F3-R-19-m">
                      {{hhmm(shiftInfo.startTime)}}発
                    </div>

                    <div class="col-md-3 column move-arrive F3-R-19-m">
                      {{hhmm(shiftInfo.arriveTime)}}着
                    </div>

                  </div>
                </td>
                <!-- shiftId -->
                <td class="bodytext shift-id F3-R-16-m" :class="trBorders[statusList[index]]" @click="goDetail(shiftInfo)" style="padding-top:0px;padding-bottom:0px">
                  <div style="height: 54px;display: flex;align-items: center;">
                    <img src="../assets/icon/transport_kind0.png" style="margin-right: 2px; height: 26px;width:26px;" v-if="shiftInfo.transportKind=='0'">
                    <img src="../assets/icon/transport_kind1.png" style="margin-right: 2px; height: 26px;width:26px;" v-if="shiftInfo.transportKind=='1'">
                    <img src="../assets/icon/app_use.png" style="margin-right: 2px; height: 26px;width:26px;" v-if="shiftInfo.routeType=='1'">
                    <img src="../assets/icon/app_dontuse.png" style="margin-right: 2px; height: 26px;width:26px;" v-if="shiftInfo.routeType=='2'">
                    {{shiftInfo.shiftId}}
                  </div>
                </td>
                <!-- parentShiftId -->
                <td class="bodytext parent-shift-id F3-R-16-m" :class="trBorders[statusList[index]]" @click="goDetail(shiftInfo)" style="padding-top:0px;padding-bottom:0px">
                  <div style="height: 54px;display: flex;align-items: center;">
                    {{shiftInfo.parentShiftId}}
                  </div>
                </td>
                <!-- shiftTitle -->
                <td class="bodytext shift-name F3-R-19-m" :class="trBorders[statusList[index]]" @click="goDetail(shiftInfo)" :title="shiftInfo.title">
                  {{shiftInfo.title}}
                </td>
                <!-- 车辆 -->
                <td class="bodytext shift-vehicle" :class="trBorders[statusList[index]]" style="padding-top:0px;padding-bottom:0px;" @click="goDetail(shiftInfo)">
                  <div v-if="shiftInfo.vehicleId!==null">
                    <!-- <div>{{shiftInfo.vehicleType}}</div> -->
                    <div class="F3-R-20-m vehicle-name" :title="shiftInfo.vehicleName">{{shiftInfo.vehicleName}}</div>
                    <div class="F3-R-17-m">ID:{{shiftInfo.displayVehicleId}}</div>
                  </div>
                  <div v-else style="line-height:53px">未定<img class="excalmatory-mark" src="@/assets/attention_mark_mid.png"></div>
                </td>
                <!-- 司机 -->
                <td class="bodytext shift-driver" :class="trBorders[statusList[index]]" @click="goDetail(shiftInfo)">
                  <div v-if="shiftInfo.driverName!==null">
                    <div class="F3-R-20-m driver-name" :title="shiftInfo.driverName">{{shiftInfo.driverName}}</div>
                  </div>
                  <div v-else>未定<img class="excalmatory-mark" src="@/assets/attention_mark_mid.png"></div>
                </td>
                <!-- 预约人数 -->
                <td class="shift-rese" :class="trBorders[statusList[index]]" style="padding:0px;" >
                  <div style="display :flex;flex-direction: row;height: 54px;align-items: center;">

                    <div style="width:50%">
                      <button class="shift-btn F2-M-15" @click="showReservationStatus(shiftInfo)">予約状況</button>
                    </div>

                    <div style="width:20%;align-self: center;"><img v-if="shiftInfo.isOverLoad" class="excalmatory-mark" src="@/assets/attention_mark_mid.png"></div>

                    <div style="width:25%;padding:2px;float:right;margin-left:5px;color: #fff;font-size: 24px;">
                      <!-- <div v-if="shiftInfo.isOverLoad || shiftInfo.rePassengerNumber>3">
                        <img src="@/assets/ride_status4.png"/>
                      </div>
                      <div v-else>
                        <img v-if="shiftInfo.rePassengerNumber===0" src="@/assets/ride_status1.png"/>
                        <img v-if="shiftInfo.rePassengerNumber===1" src="@/assets/ride_status2.png"/>
                        <img v-if="shiftInfo.rePassengerNumber===2" src="@/assets/ride_status3.png"/>
                        <img v-if="shiftInfo.rePassengerNumber===3" src="@/assets/ride_status4.png"/>
                      </div> -->
                      {{shiftInfo.rePassengerNumber}}/{{shiftInfo.passengerNumber}}
                    </div>

                  </div>
                </td>

                <!-- <td  style="width:0%;"></td> -->
                <td class="shift-status" style="padding:0px;">
                  <div class="status-div">
                    <a v-if="((statusList[index]===0) && (shiftInfo.transportKind=='0'))" href="#modal-container-regular-detail" data-toggle="modal" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">
                      <button
                        class="btn status-btn  F2-M-15-m"
                        @click="showShiftDetail(shiftInfo)"
                        :class="statusBtnBgs[0]"
                        style="color:rgb(149,149,149)"
                        onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">
                        未公開
                      </button>
                    </a>
                    <button v-else-if="((statusList[index]===5) && (shiftInfo.transportKind=='1'))" class="btn status-btn F2-M-15-m"
                    :class="statusBtnBgs[5]"
                    style="color:rgb(255,255,255)"
                    onkeydown="if(event.keyCode==13 || event.keyCode==32 )return false;">
                        未公開
                    </button>
                    <a v-else-if="((statusList[index]===1) && (shiftInfo.rePassengerNumber === 0) && (shiftInfo.transportKind=='0'))" href="#modal-container-regular-detail" data-toggle="modal" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">
                      <button
                        class="btn status-btn  F2-M-15-m"
                        @click="showShiftDetail(shiftInfo)"
                        :class="statusBtnBgs[1]"
                        style="color:rgb(255,255,255)"
                        onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">
                        公開中
                      </button>
                    </a>
                    <button v-else-if="((statusList[index]===1) && (shiftInfo.rePassengerNumber === 0) && (shiftInfo.transportKind=='1'))" class="btn status-btn F2-M-15-m"
                    :class="statusBtnBgs[2]"
                    style="color:rgb(255,255,255)"
                    onkeydown="if(event.keyCode==13 || event.keyCode==32 )return false;">
                        公開中
                    </button>
                    <a v-else-if="((statusList[index]===1) && (shiftInfo.rePassengerNumber > 0) && (shiftInfo.transportKind=='0'))" onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">
                      <button
                        class="btn status-btn  F2-M-15-m"
                        @click="showOpenFlagMessage"
                        :class="statusBtnBgs[1]"
                        style="color:rgb(255,255,255)"
                        onkeydown="if(event.keyCode==13 || event.keyCode==32)return false;">
                        公開中
                      </button>
                    </a>
                    <button v-else-if="((statusList[index]===1) && (shiftInfo.rePassengerNumber > 0) && (shiftInfo.transportKind=='1'))" class="btn status-btn F2-M-15-m"
                    :class="statusBtnBgs[2]"
                    style="color:rgb(255,255,255)"
                    onkeydown="if(event.keyCode==13 || event.keyCode==32 )return false;">
                        公開中
                    </button>
                    <button v-else class="btn status-btn F2-M-15-m"
                    :class="statusBtnBgs[statusList[index]]"
                    style="color:rgb(255,255,255)"
                    onkeydown="if(event.keyCode==13 || event.keyCode==32 )return false;">
                        {{shiftMovementStatus[statusList[index]]}}
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
      </div>
      </div>
      <movement-shift-window-mask :shift="shiftDetail" :shiftInfoList="shiftInfoList"></movement-shift-window-mask>
    </div>

    <!-- body display date day and events -->
    <div class="full-calendar-body" v-show="isCalendar" v-loading="loading" element-loading-text="ローディング中">
      <div class="weeks bgc8">
        <span class="week F3-R-19" v-for="dayIndex in 7" :key="dayIndex">{{ weeks[(dayIndex - 1)] }}</span>
      </div>

      <div class="dates" ref="dates">
        <div class="dates-bg">
          <div class="week-row" v-for="week in currentDates" :key="week.id">
            <div class="day-cell" v-for="(day,index) in week"
                 :class="{'bgc12' : day.isToday,'F1-R-27' : day.isCurMonth,'F7-R-27' : !day.isCurMonth,'bgc8':index===0||index===week.length-1}"
                 :key="day.id">
              <p class="day-number">{{ day.monthDay }}</p>
            </div>
          </div>
        </div>

        <!-- absolute so we can make dynamic td -->
        <div class="dates-events">
          <div class="events-week" v-for="week in currentDates" :key="week.id">
            <div class="events-day" v-for="day in week" track-by="$index" :key="day.id"
                 :class="{'today' : day.isToday,
              'not-cur-month' : !day.isCurMonth}" @click.stop="dayClick(day.date, $event)">
              <!-- <p class="day-number">{{day.monthDay}}</p> -->
              <div class="event-box">
                <event-card :event="event" :date="day.date" :firstDay="firstDay" v-for="event in day.events" v-show="event.cellIndex <= eventLimit" @click="eventClick" :key="event.id" :listStyle="true">
                  <template slot-scope="p">
                    <slot name="fc-event-card" :event="p.event">
                    </slot>
                  </template>
                </event-card>
                <p v-if="day.events.length > eventLimit"
                   class="more-link" @click.stop="selectThisDay(day, $event)">
                  + {{day.events[day.events.length -1].cellIndex - eventLimit}} more
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- full events when click show more -->
        <div class="more-events" v-show="showMore"
             :style="{left: morePos.left + 'px', top: morePos.top + 'px'}">
          <div class="more-header">
            <span class="title">{{ moreTitle(selectDay.date) }}</span>
            <span class="close" @click.stop="showMore = false">x</span>
          </div>
          <div class="more-body">
            <ul class="body-list">
              <li v-for="event in selectDay.events" :key="event.id"
                  v-show="event.isShow" class="body-item"
                  @click="eventClick(event, $event)" :title="event.title">
                {{event.title}}
              </li>
            </ul>
          </div>
        </div>

        <slot name="body-card">

        </slot>
        <!-- <confirm-window></confirm-window> -->
      </div>
    </div>

    <v-dialog v-show="showPrintDialog" :dialog-option="dialogPrintOption" ref="printDialog"></v-dialog>
    <print-select-dialog
        @goPrintExcel="goPrintExcel"
        @goPrint="goPrint"
        @goPrintShiftStatisticExcel="goPrintShiftStatisticExcel">
      </print-select-dialog>
    <!-- footer -->
    <div v-show="isPrint&&!isCalendar" class="row clearfix footer" style="flex:1">
      <div class="col-md-6 column">
        <button class="shift-button" style="float:right" @click="print">出力</button>
      </div>
      <div class="col-md-6 column">
        <button class="shift-button" style="float:left" @click="cancel">キャンセル</button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>@import "../assets/css/C00.css";
.comp-full-calendar {
  // font-family: "elvetica neue", tahoma, "hiragino sans gb";
  padding-top: 20px;
  padding-bottom: 20px;
  background: #fff;
  max-width: 100%; //min-width: 1000px;
  margin: 0 auto;
  ul {
    margin: 0;
    padding: 0;
  }
}

.left-btn {
  height: 60px;
  width: 32%;
  background: linear-gradient(#DCDCDC, #ffffff);
  border: 0px;
  font-size: 20px;
  padding: 5px;
  text-align: left;
  padding-left: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.full-calendar-body {
  margin-top: 20px;
  .weeks {
    display: flex;
    border-top: 1px solid rgb(148, 148, 148);
    border-bottom: 1px solid rgb(148, 148, 148);
    border-left: 1px solid rgb(148, 148, 148);
    background-color: #F0F0F0;
    .week {
      padding-top: 3px;
      flex: 1;
      text-align: center;
      border-right: 1px solid rgb(148, 148, 148);
      height: 3.5vh;
      font-size: 18px;
    }
  }
  .dates {
    position: relative;
    .week-row {
      // width: 100%;
      // position:absolute;
      border-left: 1px solid rgb(148, 148, 148);
      display: flex; // height: 108px;
      .day-cell {
        flex: 1; // min-height: 110px;
        padding: 4px;
        border-right: 1px solid rgb(148, 148, 148);
        border-bottom: 1px solid rgb(148, 148, 148);
        height: 10.7vh;
        .day-number {
          text-align: right;
          font-size: 25px;
        }
        @media screen and (max-device-width: 1480px) {
          .day-number {
            font-size: 20px;
          }
        }
        &.today {
          background-color: #DCDCDC;
        }
        &.not-cur-month {
          .day-number {
            color: #8E8E8E;
          }
        }
      }
    }
    .dates-events {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      .events-week {
        display: flex;
        .events-day {
          cursor: pointer;
          flex: 1;
          min-height: 80%;
          overflow: hidden;
          text-overflow: ellipsis;
          height: 10.7vh;
          .day-number {
            text-align: right;
            opacity: 0;
          }
          &.not-cur-month {
            .day-number {
              color: rgba(0, 0, 0, .24);
            }
          }
          .event-box {
            padding-top: 5px;
            .event-item {
              cursor: auto;
              font-size: 12px; //background-color:#C7E6FD;
              color: rgba(0, 0, 0, .87);
              padding: 0 0 0 4px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              text-align: left;
              margin-left: 10px;
              width: 75%;
              white-space: nowrap;
              &.is-start {
                margin-left: 4px; // border-top-left-radius:4px;
                // border-bottom-left-radius:4px;
              }
              &.is-end {
                margin-right: 4px; // border-top-right-radius:4px;
                // border-bottom-right-radius:4px;
              }
              &.is-opacity {
                opacity: 0;
              }
            } // .event-item:hover{
            //   height: auto;
            //   white-space: normal;
            // }
            .more-link {
              cursor: pointer; // text-align: right;
              padding-left: 8px;
              padding-right: 2px;
              color: rgba(0, 0, 0, .38);
              font-size: 14px;
            }
          }
        }
      }
    }
    .more-events {
      position: absolute;
      width: 150px;
      z-index: 2;
      border: 1px solid #eee;
      box-shadow: 0 2px 6px rgba(0, 0, 0, .15);
      .more-header {
        background-color: #eee;
        padding: 5px;
        display: flex;
        align-items: center;
        font-size: 14px;
        .title {
          flex: 1;
        }
        .close {
          margin-right: 2px;
          cursor: pointer;
          font-size: 16px;
        }
      }
      .more-body {
        height: 146px;
        overflow: hidden;
        .body-list {
          height: 144px;
          padding: 5px;
          overflow: auto;
          background-color: #fff;
          .body-item {
            cursor: pointer;
            text-align: left;
            font-size: 12px;
            background-color: #C7E6FD;
            margin-bottom: 2px;
            color: rgba(0, 0, 0, .87);
            padding: 0 0 0 4px;
            height: 18px;
            line-height: 18px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }
}

a:link,
a:visited {
  color: #444;
  text-decoration: none;
}

td {
  width: 13%; //190px
  //white-space:normal;
}

.shift-btn {
  width: 90%;
  font-size: 16px;
  border: none;
  background: linear-gradient(rgb(167, 167, 165) 50%, rgb(145, 146, 141) 50%);
  border-radius: 4px;
  margin: 3px;
  padding: 3px;
}

.person-img {
  height: 25px;
  width: 15px;
  margin-top: 5%;
}

.left-img {
  width: 40px;
  background: rgb(150, 150, 150);
  margin-right: 5px;
  float: left;
}

.htd {
  padding: 5px;
}

 .checkbox-style{
    width:20px;
    height:20px;
  }
  .checkbox-td{
    width:4%;
    padding: 0px;
  }

// .shift-move-time {
//   width: 24%;
// }

.shift-id {
  width: 12%;
}

.parent-shift-id {
  width: 7%;
}
.shift-name {
  width: 26%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.shift-vehicle {
  width: 12%;
}
.vehicle-name{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.shift-driver {
  width: 12%;
}
.driver-name{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.shift-rese {
  width: 14%;
}

.shift-status {
  width: 8%;
}

.move-day {
  border-right: 1px solid #fff;
  text-align: center;
  padding: 0px;
  width: 48%;
}

.move-start {
  border-right: 1px solid #fff;
  text-align: center;
  padding: 0px;
}

.move-arrive {
  text-align: center;
  padding: 0px;
}

.excalmatory-mark {
  height: 20px;
  margin-left: 5px;
}

.common-btn {
  width: 45%;
  height: 38px;
  border-radius: 25px;
  font-size: 18px;
  background: linear-gradient(rgb(167, 167, 165) 50%, rgb(145, 146, 141) 50%);
  border: 0px;
}

.status-btn {
  border: 0px;
  height: 28px;
  width: 84px;
}

/* 公开中 */

.status-btn-bg1 {
  padding-left: 6px;
  text-align: left;
  color: #fff;
  background: url(../assets/button/toggle_sw1.png);
}

/* 非公开 */

.status-btn-bg2 {
  padding-right: 6px;
  text-align: right;
  color: #000;
  background: url(../assets/button/toggle_sw2.png);
}

/* 运行中和终了 */

.status-btn-bg3 {
  color: #fff;
  background: url(../assets/button/toggle_sw3.png);
}

/* 非公開(区域外) */
.status-btn-bg4 {
  color: #fff;
  background: url(../assets/button/toggle_sw4.png);
}

.status-div {
  height: 100%;
  width: 100%;
  height: 52px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

  // table
  .trborder{
    border-right:1px solid rgb(190,190,190);
  }
  tr:hover {
    background-color: rgb(110, 110, 110);
  }
  .contenttr{
    height: 55px;
  }

  .table>tbody>tr>td{
    padding-top: 13px;
  }

  .footer{
    width: 100%;
    margin: 10px 0;
    display: flex;
    align-items: flex-end;
  }

  .shift-button{
    width: 60%;
    height: 50px;
    border-radius: 10px;
    background: linear-gradient(#70b6ca 50%, #48a3be 50%) !important;
    border: 0px;
    /* margin: 30px; */
    font-size: 22px;
    color: #fff;
    background-color: #717171;
  }

  .btn{
    padding-top: 0px;
    padding-bottom: 0px;
  }
  // 终了
  .border-color4{
    border-right:1px solid rgb(220,220,220);
  }
  // 运行中
  .border-color3{
    border-right:1px solid rgb(140,150,210);
  }
  // 公开中
  .border-color2{
    border-right:1px solid rgb(195,215,230);
  }
  // 未公开
  .border-color1{
    border-right:1px solid rgb(255,255,255);
  }
  // 复用共通样式
  .F3-R-19-m {
    font-family: 'Noto Sans CJK JP' !important;
    font-size: 19px !important;
    font-weight: 400 !important;
  }
  .F3-R-20-m {
    font-family: 'Noto Sans CJK JP' !important;
    font-size: 20px !important;
    font-weight: 400 !important;
  }
  .F3-R-17-m {
    font-family: 'Noto Sans CJK JP' !important;
    font-size: 17px !important;
    font-weight: 400 !important;
  }
  .F2-M-15-m {
    font-family: 'Noto Sans CJK JP' !important;
    font-size: 15px !important;
    font-weight: 500 !important;
  }
  .F1-R-27-m {
    font-family: 'Noto Sans CJK JP' !important;
    font-size: 27px !important;
    font-weight: 400 !important;
  }
  @media screen and (max-device-width: 1480px) {
    .common-btn{
      font-size: 14px;
    }
    .left-btn{
      font-size: 16px;
    }
    .contenttr{
      font-size: 14px;
    }
    .shift-btn{
      font-size: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MovementShiftComponent.vue